// returnDomain 返回对应需要跳转的域名或者Boolean
// 参数  type 为1是返回需要跳转的域名；默认返回Boolean
// 返回值 跳转的域名或者Boolean
function returnDomain() {
    let hostString = location.host;
    let val = false;
    // 礼盒营销橙色域名时
    if(hostString=='rrsmd.maboy.cn') {
        val = true;
    }
    return val;
}
export {
    returnDomain
}


// WEBPACK FOOTER //
// ./src/util/returnDomain.js